<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Volume Vendas"
      ></page-title>

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-sm-12 mb-3">
            <anosafra-multiselect
              v-model="filter.anosafra"
              label="Ano Safra"
            />
          </div>
          <div class="col-md-6 col-sm-12 mb-3">
            <label class="form-control-label">Vendedor</label>
            <multiselect
              v-model="filter.salesman"
              :options="salesmen"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :loading="isLoadingSalesman"
              :disabled="!currentUser.is_admin && !currentUser.is_manager && !currentUser.is_coordinator"
              placeholder="Selecione vendedor"
              label="name"
              track-by="id"
            />
          </div>
          <div class="col-md-4 col-sm-12 mb-3">
            <base-input
              label="Nome"
              v-model="filter.name"
              placeholder="Nome do Produto"
            />
          </div>
          <div class="col-md-4 col-sm-12 mb-3">
            <label class="form-control-label">Código</label>
            <multiselect
              v-model="filter.code"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :options="codes"
              placeholder="Selecione o código"
              :show-no-options="false"
            />
          </div>
          <div class="col-md-4 col-sm-12 mb-3">
            <label class="form-control-label">Marca</label>
            <multiselect
              v-model="filter.brand"
              :options="brands"
              placeholder="Selecione a marca"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :show-no-options="false"
            />
          </div>
          <div class="col-md-6 col-sm-12 mb-3">
            <label class="form-control-label">Grupo</label>
            <multiselect
              v-model="filter.group"
              :options="groups"
              placeholder="Selecione o grupo"
              :show-no-options="false"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              label="descricao"
              track-by="id"
            />
          </div>
          <div class="col-md-6 col-sm-12 mb-3">
            <label class="form-control-label">Subgrupo</label>
            <multiselect
              v-model="filter.subgroup"
              :options="subgroups"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="Selecione o subgrupo"
              :show-no-options="false"
              label="descricao"
              track-by="id"
            />
          </div>
        </div>

        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" @click="generatePDF">Gerar PDF</base-button>
          <base-button type="secondary" class="mt-2" @click="exportToExcel()">Gerar Excel</base-button>
          <base-button type="primary" class="ml-2 mt-2" @click="generateReport" v-loading="isLoading"
            >Gerar Relatório</base-button
          >
        </div>
      </card>
    </div>

    <card v-show="products.length" ref="report" v-loading="isLoading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Histórico - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          v-if="filter.salesman && Object.keys(filter.salesman).length"
          class="text-uppercase text-muted ls-1 mb-1"
        >
          Usuário - {{ filter.salesman.name }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="
            width: 200px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          "
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Volume de Vendas - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.salesman && Object.keys(filter.salesman).length"
        >
          Vendedor: {{ filter.salesman.name }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.anosafra && Object.keys(filter.anosafra).length"
        >
          Ano Safra: {{ filter.anosafra.descricao }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.name">
          Nome: {{ filter.name }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.code">
          Código: {{ filter.code }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.brand">
          Marca: {{ filter.brand }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.group && Object.keys(filter.group).length"
        >
          Subgrupo: {{ filter.group.descricao }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.subgroup && Object.keys(filter.subgroup).length"
        >
          Subgrupo: {{ filter.subgroup.descricao }}
        </h6>
        <br />
        <br />
        <br />
      </div>
      <el-table
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
        min-wid_typeth="500px"
        :data="products"
      >
         <el-table-column
          width="155"
          label="Código"
          prop="code"
        ></el-table-column>
        <el-table-column
          width="155"
          label="Produto"
          prop="name"
        ></el-table-column>
        <el-table-column
          width="155"
          label="Marca"
          prop="brand"
        ></el-table-column>
        <el-table-column
          width="155"
          label="Grupo"
          prop="group"></el-table-column>
        <el-table-column
          width="155"
          label="Subgrupo"
          prop="subgroup"></el-table-column>
        <el-table-column
          width="165"
          label="Unidade SGV"
        >

        </el-table-column>
        <el-table-column
          width="175"
          label="Unidade SIAGRI"
          prop="siagri_unity"
        ></el-table-column>
        <el-table-column
          width="185"
          label="Quantidade vendida"
          prop="quantity"
        />
        <el-table-column
          width="235"
          label="Total volume por unidade SGV"
          prop="total_volume"
          >
          </el-table-column
        >
      </el-table>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";

import { Table, TableColumn, DatePicker } from "element-ui";

export default {
  components: {
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      active: true,
      filter: {
        anosafra: "",
        salesman: "",
        code: "",
        name: "",
        brand: "",
        group: null,
        subgroup: null,
      },
      brands: [],
      currentUser: {},
      groups: [],
      subgroups: [],
      codes: [],
      anosafras: [],
      salesmen: [],
      products: [],
      lastEdition: new Date(),
      unityDict: {
        'K': 'KG/L',
        'U': 'UN',
        'M': 'MX'
      },
      isLoadingSalesman: false,
      isLoading: false,
    };
  },
  methods: {
    generatePDF() {
      window.print();
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    clearFilters() {
      this.filter.salesman = "",
      this.filter.name = "",
      this.filter.code = "",
      this.filter.brand = "",
      this.filter.group = null
      this.filter.subgroup = null
    },
    generateReport() {
      this.isLoading = true
      this.$http.secured
        .get("/api/v1/report/sales_volumes", {
          params: {
            "product[code]": this.filter.code ? this.filter.code : null,
            "product[description]": this.filter.name ? this.filter.name : null,
            "product[grupo_id]": this.filter.group
              ? this.filter.group.id
              : null,
            "product[subgrupo_id]": this.filter.subgroup
              ? this.filter.subgroup.id
              : null,
            "product[user_id]": this.filter.salesman
              ? this.filter.salesman.id
              : null,
            "product[anosafra]": this.filter.anosafra
              ? this.filter.anosafra.id
              : null,
            "product[brand]": this.filter.brand
              ? this.filter.brand.name
              : null,
          },
        })
        .then((response) => {
          this.lastEdition = new Date();
          this.products = response.data;
          this.isLoading = false
        })
        .catch((_e) => {
          this.isLoading = false
        });
    },
    initData() {
      this.$http.secured
        .get("/api/v1/report/sales_volumes", { params: { data: true } })
        .then((response) => {
          this.brands = response.data.brands;
          this.codes = response.data.codes;
        });
    },
    initGroups() {
      this.$http.secured.get("/api/v1/grupos").then((response) => {
        this.groups = response.data;
      });
    },
    initSubgroups() {
      this.$http.secured.get("/api/v1/subgrupos").then((response) => {
        this.subgroups = response.data;
      });
    },
    initSalesmen(query) {
      this.isLoadingSalesman = true;
      var data = {
        name_only: true,
        q: { name: query, is_salesman: true, status: this.active }
      }

      if (this.filter.manager && this.filter.manager.id)
        data.q["manager_id"] = this.filter.manager.id;
      if (this.filter.manager && this.filter.manager.coordinated_id)
        data.q["manager_id"] = this.filter.manager.coordinated_id;
      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q["anosafra_id"] = this.filter.anosafra.id;

      this.$http.secured
        .get("/api/v1/users", {params:data})
        .then((response) => {
          this.isLoadingSalesman = false;
          this.salesmen = response.data || []
        })
        .catch(() => (this.isLoadingSalesman = false))
    },
    salesQuantity(product) {
      if (product.sales_quantity) return product.sales_quantity.toFixed(2);
    },
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
  mounted() {
    this.currentUser = this.$currentUser()

    if(this.$can('index', 'user')){
      this.initSalesmen("");
    }

    if (this.currentUser.is_admin) {
      this.initSalesmen('');
    } else if (
      this.currentUser.is_manager ||
      this.currentUser.has_coordinateds
    ) {
      this.filter.managers = [this.currentUser];
      this.filter.salesmans = this.currentUser.salesmans;
      this.filter.manager = this.currentUser;
    } else if (this.currentUser.is_salesman) {
      this.filter.salesman = this.currentUser;
    }

    this.initData();
    this.initGroups();
    this.initSubgroups();
  },
  watch: {
    'filter.anosafra': function() {
       if(this.$can('index', 'user')){
        this.initSalesmen("");
      }
    }
  },
};
</script>
<style >
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}
</style>
